import { render, staticRenderFns } from "./EditSVG.vue?vue&type=template&id=1c27c3ed&"
import script from "./EditSVG.vue?vue&type=script&lang=js&"
export * from "./EditSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports